
import Vue from 'vue';
import { Icon, Avatar, Button, Tooltip } from '@descomplica/vue-components';
import { CourseModel } from '@descomplica/dex-models';
import { CourseCertificateModel } from '@/models/studentDocuments';

interface Data {
  tooltipVisible: boolean;
}

export default Vue.extend({
  components: {
    Icon,
    Avatar,
    Button,
    Tooltip,
  },
  props: {
    currentCourse: {
      type: Object as Vue.PropType<CourseModel>,
      required: true,
    },
    loadError: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      tooltipVisible: false,
    };
  },
  computed: {
    userAvatar(): string {
      return this.$store.getters.currentUserAvatar;
    },
    userCertificateInformation(): CourseCertificateModel | null {
      return this.$store.getters.certificateByCourseId(this.currentCourse.id);
    },
    certificateIssuedDate(): string {
      return this.userCertificateInformation?.certificateIssueDate || '';
    },
    formattedUserName(): string {
      if (!this.userCertificateInformation?.studentName) return '';

      const userNamesList = this.userCertificateInformation.studentName.split(' ');

      if (userNamesList.length > 1) {
        return `${userNamesList[0]} ${userNamesList.slice(-1)}`;
      }

      return this.userCertificateInformation.studentName;
    },
  },
  methods: {
    toggleTooltip(): void {
      this.tooltipVisible = !this.tooltipVisible;
    },
    emitDownloadFiles(): void {
      this.$emit('downloadFiles');
    },
    emitShareCertificate(): void {
      this.$emit('shareCertificate');
    },
    reloadPage(): void {
      this.$emit('onPageReload');
    },
  },
});
